import React from "react";
import styles from "./styles.module.scss";

const Reporting = () => {
    return <div className={styles.table}></div>;
};
export default Reporting;
